// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Theme__Color__Vars = require("../../../reason/common/Theme/Theme__Color__Vars.bs.js");

var wrapper = CssJs.style([
      CssJs.position("relative"),
      CssJs.display("inlineBlock")
    ]);

var xSmallIconStyle = CssJs.style([
      CssJs.position("absolute"),
      CssJs.left(CssJs.px(25)),
      CssJs.top(CssJs.px(21)),
      CssJs.opacity(0.4)
    ]);

var smallIconStyle = CssJs.style([
      CssJs.position("absolute"),
      CssJs.left(CssJs.px(34)),
      CssJs.top(CssJs.px(29)),
      CssJs.opacity(0.4)
    ]);

var mediumIconStyle = CssJs.style([
      CssJs.position("absolute"),
      CssJs.left(CssJs.px(38)),
      CssJs.top(CssJs.px(33)),
      CssJs.opacity(0.4)
    ]);

var largeIconStyle = CssJs.style([
      CssJs.position("absolute"),
      CssJs.left(CssJs.px(57)),
      CssJs.top(CssJs.px(49)),
      CssJs.opacity(0.4)
    ]);

function TerminatedAgentIconOverlay(props) {
  var size = props.size;
  var size$1 = size !== undefined ? size : "small";
  return React.createElement("span", {
              className: wrapper
            }, size$1 === "xLarge" ? React.createElement("span", {
                    className: largeIconStyle
                  }, React.createElement(Icon__Jsx3.make, {
                        icon: /* Unavailable */72,
                        size: 36,
                        color: Theme__Color__Vars.crimson
                      })) : (
                size$1 === "medium" ? React.createElement("span", {
                        className: mediumIconStyle
                      }, React.createElement(Icon__Jsx3.make, {
                            icon: /* Unavailable */72,
                            size: 24,
                            color: Theme__Color__Vars.crimson
                          })) : (
                    size$1 === "small" ? React.createElement("span", {
                            className: smallIconStyle
                          }, React.createElement(Icon__Jsx3.make, {
                                icon: /* Unavailable */72,
                                size: 20,
                                color: Theme__Color__Vars.crimson
                              })) : (
                        size$1 === "xSmall" ? React.createElement("span", {
                                className: xSmallIconStyle
                              }, React.createElement(Icon__Jsx3.make, {
                                    icon: /* Unavailable */72,
                                    size: 18,
                                    color: Theme__Color__Vars.crimson
                                  })) : React.createElement("span", {
                                className: largeIconStyle
                              }, React.createElement(Icon__Jsx3.make, {
                                    icon: /* Unavailable */72,
                                    size: 36,
                                    color: Theme__Color__Vars.crimson
                                  }))
                      )
                  )
              ), props.children);
}

var Icon;

var make = TerminatedAgentIconOverlay;

exports.wrapper = wrapper;
exports.xSmallIconStyle = xSmallIconStyle;
exports.smallIconStyle = smallIconStyle;
exports.mediumIconStyle = mediumIconStyle;
exports.largeIconStyle = largeIconStyle;
exports.Icon = Icon;
exports.make = make;
/* wrapper Not a pure module */
